/**
 * React entrypoint
 *
 */
import log from "loglevel";
import React from "react";
import { createRoot } from "react-dom/client";

import "./i18n";

import { devEnvironment, IS_LOCALHOST } from "@/config/Constants";
import { HelmetProvider } from "@dr.pogodin/react-helmet";
import { WMSContextProvider } from "@/contexts/wmsContext";
import AppRouter from "@/AppRouter";

import "./styles/index.scss";
import "./styles/v2/figma-theme.scss";
import "./styles/v2/figma-alerts.scss";
import "./styles/v2/figma-buttons.scss";

if (!devEnvironment) {
  // This will disable React DevTools in production
  if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    for (const [key, value] of Object.entries(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = typeof value === "function" ? () => {} : null;
    }
  }
}

if (IS_LOCALHOST) log.enableAll();
else if (localStorage.getItem("wmsEnableConsoleLogs")) log.enableAll();
else log.disableAll();

log.debug("Index.js Load");

const root = createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
    <WMSContextProvider>
      <AppRouter />
    </WMSContextProvider>
  </HelmetProvider>
);
//React.StrictMode calls App.js 2 times.
